<template>
<div>
    <filter-bar :action="filterAction"></filter-bar>
    <kt-datatable v-bind="datatableProps" ref="datatable"></kt-datatable>
</div>
</template>

<script>
import { ApiUrl } from '@/common/api.service';
import columnsManage from '../datatable/columnsManage';
import actionsManage from '../datatable/actionsManage';
import { AuthorizationHeader } from '@/common/jwt.service';
import filterBar from './filter-bar';

export default {
    components: {
        filterBar,
    },
    data() {
        return {
            query: {},
        };
    },
    methods: {
        filterAction(e, query) {
            this.query = query;

            if (this.$refs.datatable.KTDatatable) {
                this.$refs.datatable.reload();
            }
        },
    },
    computed: {
        datatableProps() {
            return {
                id: "stakeholders_datatable_manage",
                data: {
                    type: 'remote',
                    source: {
                        read: {
                            url: ApiUrl.path('stakeholders/admin'),
                            method: 'GET',
                            headers: AuthorizationHeader,
                            map: (res) => {
                                return res.data.data;
                            },
                            params: {
                                query: this.query,
                            },
                        }
                    },
                    pageSize: 10,
                    serverPaging: true,
                    serverFiltering: true,
                    serverSorting: true,
                },
                layout: {},
                pagination: false,
                sortable: true,
                columns: columnsManage,
                actions: actionsManage,
            }
        },
    },
}
</script>
